<div class="mb-3">
  <div>
    <h1 class="pb-2 border-bottom fw-light" data-testid="sku-edit-heading"
        [attr.data-mode]="id ? 'edit' : 'create'" i18n>
      Artikel @if (id) {
<span>(bearbeiten)</span>
}
      @if (!id) {
<span>(anlegen)</span>
}
    </h1>

  @if (!id) {
    <app-scan (identificationProcessed)="applyFromIdentificationResponse($event)">
    </app-scan>
  }

  <div class="mt-5">
  @if (productForm) {
    <form [formGroup]="productForm">
      @if (isImported) {
        <div class="alert alert-info" role="alert" i18n="@@sku.imported.editHint">
          Dieser Artikel stammt aus einem Scan-Import. Name, Beschreibung und Preise sind
          schreibgeschützt – sie werden beim nächsten Scan automatisch überschrieben. Kategorie,
          Steuersatz und Sichtbarkeit können Sie weiterhin bearbeiten.
        </div>
      }
      @if (isVatUndetermined) {
        <!-- Backend #579 (slice 1): the listing carries the undetermined VAT sentinel. -->
        <div class="alert alert-warning" role="alert" i18n="@@sku.vatUndetermined.editHint">
          Für diesen Artikel ist noch kein Mehrwertsteuersatz festgelegt. Er ist für Käufer
          unsichtbar und nicht bestellbar, bis Sie unten einen MwSt.-Satz wählen und speichern.
        </div>
      }
      @if (vatSuggestion) {
        <!-- Backend #579 (slice 2): the chain's pending VAT suggestion — the seller decides. -->
        <div class="alert alert-info d-flex flex-wrap align-items-center gap-2" role="status">
          <div class="flex-grow-1">
            <strong i18n="@@sku.vatSuggestion.title">Vorschlag für den MwSt.-Satz:</strong>
            <span class="ms-1"
              >{{ vatSuggestion.percentage ?? '?' }} %
              <small class="text-muted"
                >({{ vatSuggestionSourceLabel(vatSuggestion.source) }},
                <ng-container i18n="@@sku.vatSuggestion.confidence">Konfidenz</ng-container>
                {{ vatSuggestion.confidence | percent: '1.0-0' }})</small
              ></span
            >
            @if (vatSuggestion.reason) {
              <div class="small text-muted">{{ vatSuggestion.reason }}</div>
            }
          </div>
          <div class="d-flex gap-2">
            <button
              type="button"
              class="btn btn-sm btn-primary"
              [asyncClick]="acceptVatSuggestion.bind(this)"
              [lockGroup]="vatSuggestionLock"
              #accept="asyncClick"
              [disabled]="accept.disabled"
            >
              @if (accept.busy) {
                <span class="spinner-border spinner-border-sm me-1"></span>
              }
              <span i18n="@@sku.vatSuggestion.accept">Übernehmen</span>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              [asyncClick]="dismissVatSuggestion.bind(this)"
              [lockGroup]="vatSuggestionLock"
              #dismiss="asyncClick"
              [disabled]="dismiss.disabled"
            >
              <span i18n="@@sku.vatSuggestion.dismiss">Verwerfen</span>
            </button>
          </div>
        </div>
      }
      <div class="row mt-3">
        <div class="col-sm-6">
          @if (profile?.customer.isRetailer) {
            <app-form-row label="Artikelnummer" i18n-label>
              <input
                id="number"
                type="text"
                formControlName="number"
                class="form-control form-control-sm"
                />
              @if (productForm.errors && productForm.errors['invalidNumber']) {
                <div
                  class="invalid-feedback d-block"
                  i18n
                  >
                Die Angabe der Artikelnummer ist erforderlich
              </div>
              }
            </app-form-row>
          }
          @if (profile?.customer.isRetailer) {
            <app-form-row label="Kurzbezeichnung" i18n-label>
              <input
                id="shortName"
                type="text"
                formControlName="shortName"
                class="form-control form-control-sm"
                />
              @if (productForm.errors && productForm.errors['invalidShortName']) {
                <div
                  class="invalid-feedback d-block"
                  i18n
                  >
                Die Angabe der Kurzbezeichnung ist erforderlich
              </div>
              }
            </app-form-row>
          }
          <app-form-row label="Name 1" i18n-label>
            <input
              type="text"
              formControlName="name1"
              class="form-control form-control-sm"
              />
          </app-form-row>
          <app-form-row label="Beschreibung" i18n-label>
            <textarea
              rows="5"
              type="text"
              formControlName="description"
              class="form-control form-control-sm"
            ></textarea>
          </app-form-row>
          @if (isGrossInvoiceType) {
            <app-form-row label="VK brutto" i18n-label>
              <input
                type="number"
                formControlName="catalogGrossPrice"
                class="form-control form-control-sm"
                />
            </app-form-row>
          }
          @if (!isGrossInvoiceType) {
            <app-form-row label="VK netto" i18n-label>
              <input
                type="number"
                formControlName="catalogNetPrice"
                class="form-control form-control-sm"
                />
            </app-form-row>
          }
          <app-form-row label="Verfügbare Menge" i18n-label rowClass="row mt-4 mb-2">
            <input
              type="number"
              formControlName="availableQuantity"
              class="form-control form-control-sm"
              />
          </app-form-row>
        </div>
        <div class="col-sm-6">
          <app-form-row label="Artikelkategorie" i18n-label>
            <!-- #633 A: 0..n category tags — chips, filterable, clearable; an empty
                 selection is a deliberately uncategorized listing. -->
            <kendo-multiselect
              [data]="productCategories"
              formControlName="productCategoryIds"
              textField="name"
              valueField="id"
              [valuePrimitive]="true"
              [kendoDropDownFilter]="{ operator: 'contains' }"
              [clearButton]="true"
              i18n-placeholder
              placeholder="Keine Kategorie"
              (valueChange)="onCategoriesChange($event)"
            ></kendo-multiselect>
          </app-form-row>
          @if (isVatRequired) {
            <app-form-row label="MwSt.-Satz" i18n-label>
              <!-- #178: labelled by VatLabelPipe's rule rather than by the raw number, so a
                   rate reads „19 %" and the sentinel „Unbestimmt" / „Undetermined" instead of
                   the backend's German shortName. -->
              <kendo-dropdownlist
                [data]="vatItems"
                formControlName="vatId"
                textField="label"
                valueField="id"
                [valuePrimitive]="true"
              ></kendo-dropdownlist>
              @if (isVatUndetermined) {
                <div class="form-text text-warning" i18n="@@sku.vatUndetermined.fieldHint">
                  Noch nicht festgelegt – bitte einen Steuersatz wählen.
                </div>
              }
            </app-form-row>
          }
          <app-form-row label="Status" i18n-label>
            <div class="form-check mt-2">
              <input
                name="isActive"
                id="isActive"
                class="form-check-input"
                type="checkbox"
                formControlName="isActive"
                />
              <label for="isActive" class="form-check-label" i18n>Produkt ist aktiv</label>
            </div>
          </app-form-row>
            <div class="row mt-4 mb-2">
              <div class="row">
                <label class="col-sm-4 col-form-label col-form-label-sm mb-2" i18n
                  >Artikelbilder</label
                  >
                </div>
                <app-file-select
                  #fileselect
                  [Files]="fileTransactions"
                  (fileAdded)="fileAdded($event)"
                  (fileRemoved)="fileRemoved($event)"
                  >
                </app-file-select>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end gap-2 mt-4">
            <button class="btn btn-secondary" type="button" (click)="onBackClicked()" i18n>
              Zurück
            </button>
            <button
              class="btn btn-primary"
              type="button"
              [asyncClick]="submitForm.bind(this)"
              [disabled]="saveBtn.disabled || (productForm.pristine && !filesChanged) || productForm.invalid"
              #saveBtn="asyncClick"
              data-testid="sku-edit-submit-button"
              i18n
              >
              @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
              Bestätigen
            </button>
          </div>
        </form>
      }
    </div>
  </div>
</div>
